import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CommonService} from "../../../../shared/services/common.service";
import {Subject, takeUntil} from "rxjs";
import {roleUrlMap} from "../../../../shared/constants/common.constants";
import {Store} from "@ngrx/store";
import * as moment from "moment/moment";
import {ActivatedRoute, Router} from "@angular/router";
import {UpdateSessionDetailsRequest} from "../../core/sessions-list.actions";

@Component({
  selector: "app-session-reschedule",
  templateUrl: "./session-reschedule.component.html",
  styleUrls: ["./session-reschedule.component.css"]
})
export class SessionRescheduleComponent implements OnInit {
  @Input() data;
  private readonly onDestroy: Subject<any> = new Subject<any>();
  sessionData: any;
  backToPopup: any;
  minDate = null;
  maxDate = null;

  errorMessages: any = {};
  errorMessageMap = {
    sessionDate: {
      required: "This field is required.",
    },
    startTime: {
      required: "This field is required.",
    },
    duration: {
      required: "This field is required.",
    },
  };
  form = new FormGroup<any>({
    sessionDate: new FormControl({value: "", disabled: false}, {
      validators: [
        Validators.required
      ]
    }),
    startTime: new FormControl({value: "", disabled: false}, {
      validators: [
        Validators.required
      ]
    }),
    duration: new FormControl({value: "", disabled: false}, {
      validators: [
        Validators.required
      ]
    }),
  });

  constructor(
    private commonService: CommonService,
    private store: Store,
    private route: ActivatedRoute,
    private router: Router,
    private cdRef: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.sessionData = this.data?.data;

    this.minDate = this.sessionData.prevDate && moment(this.sessionData.prevDate)
      .add(1, 'd').toISOString() || null;
    this.maxDate = this.sessionData.nextDate && moment(this.sessionData.nextDate)
      .subtract(1, 'd').toISOString() || null;



    this.backToPopup = this.route.snapshot.queryParamMap.get('backToPopup');

    const meetingOn = moment.utc(this.sessionData?.meetingOn).local().format();


    this.form.patchValue({
      sessionDate: meetingOn,
      startTime: meetingOn,
      duration: this.sessionData?.duration
    }, {emitEvent: true});
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  handleSubmit() {
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }

    if (!this.form.dirty) {
      return;
    }

    const {
      sessionDate,
      startTime,
      duration
    } = this.form.getRawValue();

    const payload = {
      startDate: [
        moment(sessionDate)?.toISOString()?.split('T')[0],
        moment(startTime)?.toISOString().split('T')[1]
      ].join('T'),
      duration: duration,
      groupId: this.data?.groupId,
      sessionId: this.sessionData?.sessionNumber
    };

    this.store.dispatch(UpdateSessionDetailsRequest({payload, isSessionList: true}));

  }

  handleCancel() {
    this.commonService.closeDialog();
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
